module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/2_icon-ebda32b2b6fda18dfab96a1ac4afe3dd.png";